var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from "react";
import SearchPanelWithPopupFiltersLabel from "@frameworks/shared-library/components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel";
import "../TransferIn/TransferIn.scss";
import TransferInProfileDetails from "./TransferInProfileDetails";
import useCalculateZoom from "@frameworks/web/utils/useCalculateZoom";
import DynamicPagination from "@frameworks/shared-library/components/Pagination/Pagination";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import { ESortOrder } from "@domains/features/Markets/MutualFunds/dto/MutualFundsSchemesDTO";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { useNavigate } from "react-router-dom";
import { alphabetsColorsConfigMap } from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/colorConfigurationsForTextFirstAlphabetAsIcon";
import { getArnTransferInDetails, } from "@frameworks/arn-transfer/api/ArnTransferInDetails";
import GenericTableShimmer from "@frameworks/shared-library/components/GenericTableShimmer/GenericTableShimmer";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import ConfirmationPopup from "@frameworks/shared-library/components/ConfirmationPopup/ConfirmationPopup";
import PopupConfirmation from "@frameworks/shared-library/components/Offerings/Generic/PopUpConfirmation/PopUpConfirmation";
import successSvg from "@frameworks/shared-library/assets/images/SalesJourney/txn-success.svg";
import { generateFormData, } from "@frameworks/arn-transfer/api/ArnGenerateForm";
import { base64toPDF } from "@frameworks/salesjourney/utils/genericMethods";
import di from "@mainDi/features/ActivityBook/OrderBook/MutualFund/servicelocator";
import { EMutualFundOrderTabs } from "@domains/features/ActivityBook/OrderBook/MutualFund/entities/IMutualFundTransactionsCommonEntity";
var TransferIn = function () {
    var _a, _b;
    var zoom = useCalculateZoom();
    var navigate = useNavigate();
    var _c = __read(useState(), 2), queryData = _c[0], setqueryData = _c[1];
    var _d = __read(useState({ type: ESortOrder.DESCENDING, sortKey: "sch_name" }), 2), sortType = _d[0], setSortType = _d[1];
    var _e = __read(useState(false), 2), tableLoader = _e[0], setTableLoader = _e[1];
    var _f = __read(useState(), 2), tableData = _f[0], setTableData = _f[1];
    var _g = __read(useState(false), 2), transferFormPopup = _g[0], setTransferFormPopup = _g[1];
    var _h = __read(useState([]), 2), checkedData = _h[0], setCheckedData = _h[1];
    var _j = __read(useState(0), 2), noOfDownloadFiles = _j[0], setNoOfDownloadFiles = _j[1];
    var handleSelectAll = function (e) {
        var _a;
        var allCheckedData = [];
        if (e.target.checked) {
            allCheckedData = (_a = tableData === null || tableData === void 0 ? void 0 : tableData.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                return {
                    isin_code: item === null || item === void 0 ? void 0 : item.isin_code,
                    ucccode: item === null || item === void 0 ? void 0 : item.ucccode,
                    folio_no: item === null || item === void 0 ? void 0 : item.folio_no,
                    amc_logo: item === null || item === void 0 ? void 0 : item.amc_logo,
                    rtaname: item === null || item === void 0 ? void 0 : item.rtaname,
                };
            });
        }
        setCheckedData(allCheckedData);
    };
    var handleInputCheck = function (e, keys) {
        var isChecked = e.target.checked;
        setCheckedData(function (prev) {
            if (isChecked) {
                return __spreadArray(__spreadArray([], __read(prev), false), [
                    {
                        isin_code: keys[0],
                        ucccode: keys[1],
                        folio_no: keys[2],
                        amc_logo: keys[3],
                        rtaname: keys[4],
                    },
                ], false);
            }
            var updatedData = prev === null || prev === void 0 ? void 0 : prev.filter(function (val) { return (val === null || val === void 0 ? void 0 : val.isin_code) !== keys[0] && (val === null || val === void 0 ? void 0 : val.folio_no) !== keys[2]; });
            return updatedData;
        });
    };
    var mfFoliosColumn = [
        {
            columnName: (React.createElement("div", { className: "d-flex align-items-center justify-content-center fund-checkbox common-checkbox-custom small-checkbox" },
                React.createElement(GenericCheckbox, { checkboxProps: {
                        checked: !!(checkedData === null || checkedData === void 0 ? void 0 : checkedData.length),
                        onChange: function (e) {
                            handleSelectAll(e);
                        },
                        ref: function (e) {
                            if (!!e) {
                                e.indeterminate = e.checked
                                    ? (checkedData === null || checkedData === void 0 ? void 0 : checkedData.length) !== (tableData === null || tableData === void 0 ? void 0 : tableData.data.length)
                                    : false;
                            }
                        },
                    }, checkboxType: "han-blue" }))),
            keysForCustomFunction: [
                "isin_code",
                "ucccode",
                "folio_no",
                "amc_logo",
                "rtaname",
            ],
            tdCustomFunction: function (keys) {
                return (React.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, className: "fund-checkbox common-checkbox-custom small-checkbox" },
                    React.createElement(GenericCheckbox, { checkboxProps: {
                            checked: checkedData === null || checkedData === void 0 ? void 0 : checkedData.some(function (item) { return (item === null || item === void 0 ? void 0 : item.isin_code) === keys[0] && (item === null || item === void 0 ? void 0 : item.folio_no) === keys[2]; }),
                            onChange: function (e) {
                                handleInputCheck(e, keys);
                            },
                        }, checkboxType: "han-blue" })));
            },
        },
        {
            columnName: "Scheme Name",
            sortKey: "sch_name",
            arrows: true,
            columnClassName: "",
            applySorting: true,
            keysForCustomFunction: ["sch_name", "isin_code", "amc_logo"],
            tdCustomFunction: function (keys) {
                return (React.createElement(GenericSchemeName, { name: keys[0], subText1: keys[1], showImage: true, image: keys[2], textAndBackgroundColorCollectionConfig: alphabetsColorsConfigMap, maxWidth: 305, showTooltip: true }));
            },
        },
        {
            columnName: "Folio No.",
            key: "folio_no",
            sortKey: "folio_no",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            arrowClassName: "justify-content-end",
        },
        {
            columnName: "Available Units",
            key: "aval_unit",
            sortKey: "aval_unit",
            arrows: false,
            columnClassName: "text-end",
            applySorting: false,
            arrowClassName: "justify-content-end",
            tdCustomFunction: function (key) { return (React.createElement("div", { className: "d-flex flex-column gap-1" },
                React.createElement("span", { className: "RobotoM_14_500" }, key))); },
        },
        {
            columnName: "Current Nav (₹)",
            key: "current_nav",
            sortKey: "current_nav",
            arrows: false,
            columnClassName: "text-end",
            applySorting: false,
            arrowClassName: "justify-content-end",
            tdCustomFunction: function (key) { return (React.createElement("div", { className: "d-flex flex-column gap-1" },
                React.createElement("span", { className: "RobotoM_14_500" }, key))); },
        },
        {
            columnName: "Current Value (₹)",
            key: "current_val",
            sortKey: "current_val",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            arrowClassName: "justify-content-end",
            tdCustomFunction: function (key) { return (React.createElement("div", { className: "d-flex flex-column gap-1" },
                React.createElement("span", { className: "RobotoM_14_500" }, key))); },
        },
    ];
    var handleCallbackSort = function (e) {
        getArnTransferInTableData({ orderby: e.sortKey, orderbydesc: !e.type });
        setSortType(function () { return ({
            type: e.type ? ESortOrder.ASCENDING : ESortOrder.DESCENDING,
            sortKey: e.sortKey,
        }); });
    };
    var getArnTransferInTableData = function (params) {
        var _a, _b;
        setTableLoader(true);
        var payload = {
            sync_id: (params === null || params === void 0 ? void 0 : params.sync_id) ? params === null || params === void 0 ? void 0 : params.sync_id : queryData === null || queryData === void 0 ? void 0 : queryData.sync_id,
            uccCode: (params === null || params === void 0 ? void 0 : params.uccCode) ? params === null || params === void 0 ? void 0 : params.uccCode : queryData === null || queryData === void 0 ? void 0 : queryData.ucccode,
            searchValue: (_a = params === null || params === void 0 ? void 0 : params.searchValue) !== null && _a !== void 0 ? _a : "",
            tabId: 0,
            clientTierId: "",
            page_index: 1,
            page_size: 100,
            orderbydesc: !!(params === null || params === void 0 ? void 0 : params.orderbydesc),
            orderby: (_b = params === null || params === void 0 ? void 0 : params.orderby) !== null && _b !== void 0 ? _b : "",
        };
        getArnTransferInDetails(payload)
            .then(function (resp) {
            setTableData(resp);
            setTableLoader(false);
        })
            .catch(function (err) {
            setTableLoader(false);
        });
    };
    var getGenerateFormData = function () {
        var payload = {
            folioNumber: (checkedData === null || checkedData === void 0 ? void 0 : checkedData.map(function (detail) { return detail === null || detail === void 0 ? void 0 : detail.folio_no; }).join(",")) || "",
            isinCode: (checkedData === null || checkedData === void 0 ? void 0 : checkedData.map(function (detail) { return detail === null || detail === void 0 ? void 0 : detail.isin_code; }).join(",")) || "",
            syncId: queryData === null || queryData === void 0 ? void 0 : queryData.sync_id,
            uccCode: queryData === null || queryData === void 0 ? void 0 : queryData.ucccode,
            arnStatus: "In Progress",
            isDownload: true,
        };
        generateFormData(payload)
            .then(function (resp) {
            var _a, _b;
            if (resp === null || resp === void 0 ? void 0 : resp.data) {
                base64toPDF((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.Content, (_b = resp === null || resp === void 0 ? void 0 : resp.data) === null || _b === void 0 ? void 0 : _b.FileName);
            }
        })
            .catch(function (err) { });
    };
    useEffect(function () {
        if ((checkedData === null || checkedData === void 0 ? void 0 : checkedData.length) > 0) {
            // Group folios by RTA name
            var rtaGroups = checkedData.reduce(function (acc, item) {
                var rtaName = item === null || item === void 0 ? void 0 : item.rtaname;
                if (rtaName) {
                    if (!acc[rtaName]) {
                        acc[rtaName] = [];
                    }
                    acc[rtaName].push(item);
                }
                return acc;
            }, {});
            // Calculate files needed for each RTA (10 folios per file)
            var FOLIOS_PER_FILE_1 = 10;
            var totalFiles_1 = 0;
            Object.values(rtaGroups).forEach(function (folios) {
                var filesForThisRta = Math.ceil(folios.length / FOLIOS_PER_FILE_1);
                totalFiles_1 += filesForThisRta;
            });
            setNoOfDownloadFiles(totalFiles_1);
        }
        else {
            setNoOfDownloadFiles(0);
        }
    }, [checkedData]);
    useEffect(function () {
        var queryParams = new URLSearchParams(location.search);
        var encoded = queryParams.get("details");
        if (encoded) {
            var decoded = JSON.parse(atob(encoded));
            getArnTransferInTableData({
                sync_id: decoded === null || decoded === void 0 ? void 0 : decoded.sync_id,
                uccCode: decoded === null || decoded === void 0 ? void 0 : decoded.ucccode,
            });
            setqueryData(decoded);
        }
    }, [location.search]);
    var handleNavigateToOrderbook = function () {
        di.mutualFundOrderBook.updateCurrentSelectedTransactionTab(EMutualFundOrderTabs.TRANSFER_IN);
        navigate("/dashboard/orderbook", { state: { selectedDetails: tableData } });
    };
    return (React.createElement("div", { className: "transfer-in-container", style: { zoom: zoom } },
        React.createElement(TransferInProfileDetails, { profileDetails: queryData }),
        React.createElement("div", { className: "body-section", style: {
                height: (checkedData === null || checkedData === void 0 ? void 0 : checkedData.length) > 0
                    ? "calc(100vh - 310px)"
                    : "calc(100vh - 192px)",
            } },
            React.createElement("div", { className: "DMSansBold_20_700" }, "Select Mutual Funds Folios to transfer-in"),
            React.createElement(SearchPanelWithPopupFiltersLabel, { parentClassName: "transfer-in-search-pannel", searchBarParentClassName: "w-400", placeholder: "Search by scheme/folio/isin", applySearchedFilters: function (e) {
                    getArnTransferInTableData({ searchValue: e });
                }, isShowPopup: false, autoComplete: "off", delay: 400 }),
            tableLoader && (React.createElement(GenericTableShimmer, { rowCount: 10, columnCount: 5, columnsWidthClass: "table-shimmer-col-fr2-1-1-1-2" })),
            ((_a = tableData === null || tableData === void 0 ? void 0 : tableData.data) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (React.createElement(DynamicPagination, { dataLengthPerPage: 10, data: tableData === null || tableData === void 0 ? void 0 : tableData.data, Bodycomponent: GenericTable, rowClassName: "", columns: mfFoliosColumn, parentClassName: "mf-folios-transfer-in-table", infinityScroll: true, sortIconUp: "edel-icon-arrow-up-thin", sortIconDown: "edel-icon-arrow-down", viewAll: true, isPageFromParent: true, callbackSorted: function (e) {
                    handleCallbackSort(e);
                }, selectedSortVal: sortType.type, selectedSortColumnVal: sortType.sortKey })) : (React.createElement("div", { className: "custom-error-state" },
                React.createElement(Errormsg, { image: noResultsFound, msg: "No Data Found" })))),
        (checkedData === null || checkedData === void 0 ? void 0 : checkedData.length) > 0 && (React.createElement("div", { className: "footer-section" },
            React.createElement("div", { className: "d-flex align-items-center" },
                React.createElement("div", { className: "image-stack", style: { width: "".concat(Math.min(checkedData === null || checkedData === void 0 ? void 0 : checkedData.length, 5) * 30, "px") } }, (_b = checkedData === null || checkedData === void 0 ? void 0 : checkedData.slice(0, 5)) === null || _b === void 0 ? void 0 : _b.map(function (details, idx) {
                    return (React.createElement("img", { key: idx, src: details === null || details === void 0 ? void 0 : details.amc_logo, alt: "img-".concat(idx), style: { left: "".concat(idx * 21, "px"), zIndex: 5 - idx } }));
                })),
                React.createElement("div", { className: "txt-darkSapphire DMSans_13_400" },
                    "You've selected ", checkedData === null || checkedData === void 0 ? void 0 :
                    checkedData.length,
                    " folios for Transfer-In.",
                    noOfDownloadFiles > 1
                        ? " ".concat(noOfDownloadFiles, " download files will be created.")
                        : "")),
            React.createElement("div", { className: "d-flex align-items-center btn-block" },
                React.createElement(EdButton, { btnTyp: "text-only", value: "Cancel", type: "button", className: "w-100 transfer-in text-nowrap", onClick: function () {
                        navigate("/dashboard/mf-transfer", { replace: true });
                    } }),
                React.createElement(EdButton, { btnTyp: "tomato-filled-rounded", value: "Create Transfer Form", type: "button", className: "w-100 transfer-in text-nowrap", onClick: function () {
                        getGenerateFormData();
                        setTransferFormPopup(true);
                    } })))),
        transferFormPopup && (React.createElement(ConfirmationPopup, { show: true, popTitle: "transfer-in-pop", showFooter: false, popupClass: "", isShowHeader: false },
            React.createElement(PopupConfirmation, { onFirsBtnClick: handleNavigateToOrderbook, onClose: function () {
                    setTransferFormPopup(false);
                }, onSecondBtnClick: function () {
                    getGenerateFormData();
                }, message: "Transfer-In Request Form Created", description: React.createElement("div", null,
                    React.createElement("div", { className: "text-nowrap mb-3" },
                        "The Transfer-In Request Form has been auto-downloaded.",
                        React.createElement("div", null, " If not, download it below.")),
                    React.createElement("div", null, "We have pre-filled the form using the selected MF folios. Please verify and submit the client's signed form to RTA.")), confirmationImageSrc: successSvg, buttonFirstTitle: "View Orderbook", buttonSecTitle: "Download" })))));
};
export default TransferIn;
